// Cart Drawer Progress Bar js

window.itgCartAvailabilityRefreshTimer = null;
window.itgCartAvailabilityInFlight = false;
window.itgCartAvailabilityObserver = null;
window.itgCartAvailabilityObservedElement = null;
window.itgCartUpdatedListenerBound = false;
window.itgCartAvailabilityPending = false;
window.itgCartAvailabilityUnlockTimer = null;

function itgGetCheckoutLockUtils() {
    function fallbackSetCheckoutButtonDisabledState(btn, shouldDisable) {
        btn.disabled = shouldDisable;
        btn.style.opacity = shouldDisable ? 0.5 : 1;
        btn.style.pointerEvents = shouldDisable ? 'none' : 'auto';
    }

    function fallbackResolveTermsCheckboxForCheckoutButton(btn) {
        var current = btn.parentElement;
        while (current && current !== document.body) {
            var scopedCheckbox = current.querySelector('#AgreeToTos');
            if (scopedCheckbox) {
                return scopedCheckbox;
            }
            current = current.parentElement;
        }

        var allCheckoutButtons = Array.from(document.querySelectorAll('button#CheckOut'));
        var allTermsCheckboxes = Array.from(document.querySelectorAll('#AgreeToTos'));
        var buttonIndex = allCheckoutButtons.indexOf(btn);
        if (buttonIndex > -1 && allTermsCheckboxes[buttonIndex]) {
            return allTermsCheckboxes[buttonIndex];
        }

        return document.querySelector('#AgreeToTos');
    }

    return {
        setCheckoutButtonDisabledState:
            typeof window.itgSetCheckoutButtonDisabledState === 'function'
                ? window.itgSetCheckoutButtonDisabledState
                : fallbackSetCheckoutButtonDisabledState,
        resolveTermsCheckboxForCheckoutButton:
            typeof window.itgResolveTermsCheckboxForCheckoutButton === 'function'
                ? window.itgResolveTermsCheckboxForCheckoutButton
                : fallbackResolveTermsCheckboxForCheckoutButton
    };
}

function itgToggleCheckoutAvailabilityPendingFallback(isPending) {
    if (typeof window.itgSetCheckoutAvailabilityPending === 'function') {
        window.itgSetCheckoutAvailabilityPending(isPending);
        return;
    }

    var checkoutBtns = document.querySelectorAll('button#CheckOut');
    var lockUtils = itgGetCheckoutLockUtils();

    checkoutBtns.forEach(function (btn) {
        if (isPending) {
            btn.setAttribute('data-availability-pending-disabled', 'true');
        } else if (btn.getAttribute('data-availability-pending-disabled') === 'true') {
            btn.removeAttribute('data-availability-pending-disabled');
        }

        var hasDeliveryConflict = btn.getAttribute('data-delivery-conflict-disabled') === 'true';
        var termsCheckbox = lockUtils.resolveTermsCheckboxForCheckoutButton(btn);

        if (hasDeliveryConflict || (termsCheckbox && !termsCheckbox.checked)) {
            lockUtils.setCheckoutButtonDisabledState(btn, true);
            return;
        }

        lockUtils.setCheckoutButtonDisabledState(btn, false);
    });
}

function itgScheduleAvailabilityRefresh(options = {}) {
    var delay = typeof options.delay === 'number' ? options.delay : 250;
    var forceReset = options.forceReset !== false;

    if (typeof window.itgSetCheckoutAvailabilityPending === 'function') {
        window.itgSetCheckoutAvailabilityPending(true);
    } else {
        itgToggleCheckoutAvailabilityPendingFallback(true);
    }

    clearTimeout(window.itgCartAvailabilityRefreshTimer);
    window.itgCartAvailabilityRefreshTimer = setTimeout(function () {
        if (window.itgCartAvailabilityInFlight) {
            window.itgCartAvailabilityPending = true;
            return;
        }
        if (typeof window.itgCheckAvailITG !== 'function') {
            window.itgCartAvailabilityPending = false;
            if (typeof window.itgSetCheckoutAvailabilityPending === 'function') {
                window.itgSetCheckoutAvailabilityPending(false);
            } else {
                itgToggleCheckoutAvailabilityPendingFallback(false);
            }
            return;
        }

        window.itgCartAvailabilityInFlight = true;
        window.itgCartAvailabilityPending = false;
        if (forceReset) {
            document
                .querySelectorAll('#itg-shipping-availability, #itg-item-shipping-availability')
                .forEach(function (elm) {
                    elm.remove();
                });
        }

        var releaseInFlight = function () {
            clearTimeout(window.itgCartAvailabilityUnlockTimer);
            window.itgCartAvailabilityUnlockTimer = setTimeout(function () {
                window.itgCartAvailabilityInFlight = false;
                if (typeof window.itgSetCheckoutAvailabilityPending === 'function') {
                    window.itgSetCheckoutAvailabilityPending(false);
                } else {
                    itgToggleCheckoutAvailabilityPendingFallback(false);
                }
                if (window.itgCartAvailabilityPending) {
                    window.itgCartAvailabilityPending = false;
                    itgScheduleAvailabilityRefresh({ forceReset: false, delay: 180 });
                }
            }, 1200);
        };

        var checkResult = window.itgCheckAvailITG();
        if (checkResult && typeof checkResult.then === 'function') {
            checkResult.then(releaseInFlight, releaseInFlight);
            return;
        }

        releaseInFlight();
    }, delay);
}

function itgInitCartAvailabilityObserver() {
    var cartForm = document.getElementById('AjaxCartForm');

    if (
        window.itgCartAvailabilityObserver &&
        window.itgCartAvailabilityObservedElement &&
        !document.body.contains(window.itgCartAvailabilityObservedElement)
    ) {
        window.itgCartAvailabilityObserver.disconnect();
        window.itgCartAvailabilityObserver = null;
        window.itgCartAvailabilityObservedElement = null;
        window.itgCartUpdatedListenerBound = false;
    }

    if (!cartForm) return;

    if (
        window.itgCartAvailabilityObserver &&
        window.itgCartAvailabilityObservedElement === cartForm
    ) {
        return;
    }

    if (window.itgCartAvailabilityObserver) {
        window.itgCartAvailabilityObserver.disconnect();
        window.itgCartAvailabilityObserver = null;
        window.itgCartUpdatedListenerBound = false;
    }

    if (!window.itgCartUpdatedListenerBound) {
        cartForm.addEventListener('cart-updated', function () {
            itgScheduleAvailabilityRefresh({ forceReset: true, delay: 220 });
            if (typeof window.itgScheduleDisableAddButtonsRefresh === 'function') {
                window.itgScheduleDisableAddButtonsRefresh(180);
            }
        });
        window.itgCartUpdatedListenerBound = true;
    }

    window.itgCartAvailabilityObserver = new MutationObserver(function (mutations) {
        var shouldRefresh = false;

        mutations.forEach(function (mutation) {
            if (shouldRefresh) return;

            mutation.addedNodes.forEach(function (node) {
                if (shouldRefresh || node.nodeType !== 1) return;

                if (
                    node.matches('[data-shipping-id], [data-shipping-item-id], pickup-availability-compact') ||
                    node.querySelector('[data-shipping-id], [data-shipping-item-id], pickup-availability-compact') ||
                    node.matches('span.delivery.alert--circle-loading[data-drawer="true"][data-shipping-id]') ||
                    node.querySelector('span.delivery.alert--circle-loading[data-drawer="true"][data-shipping-id]')
                ) {
                    shouldRefresh = true;
                }
            });
        });

        if (shouldRefresh) {
            itgScheduleAvailabilityRefresh({ forceReset: true, delay: 220 });
        }
    });

    window.itgCartAvailabilityObserver.observe(cartForm, {
        childList: true,
        subtree: true,
    });
    window.itgCartAvailabilityObservedElement = cartForm;
}

window.itgScheduleAvailabilityRefresh = itgScheduleAvailabilityRefresh;
window.itgInitCartAvailabilityObserver = itgInitCartAvailabilityObserver;

function itgReadAssemblyEligibility() {
    var eligibility = localStorage.getItem('eligibility');
    return eligibility?.toLowerCase() === 'true'
        ? true
        : eligibility?.toLowerCase() === 'false'
            ? false
            : null;
}

function itgApplyAssemblyEligibilityState(isEligible) {
    var cartWrapper = document.querySelector('#site-cart-sidebar .cart-form');
    var mainCartWrapper = document.querySelector('.template-cart .cart-section');

    if (cartWrapper) {
        cartWrapper.classList.toggle('hide_assembly_variants', !isEligible);
    }
    if (mainCartWrapper) {
        mainCartWrapper.classList.toggle('hide_assembly_variants', !isEligible);
    }

    var mainCartDrawerWrapper = cartWrapper?.querySelector('.cart__items');
    var mainCartPageWrapper = mainCartWrapper?.querySelector('.cart-form__items');
    var hasAssemblyMessage = false;

    if (mainCartPageWrapper) {
        mainCartPageWrapper.querySelectorAll('.cart-form-item').forEach(function (wrapper) {
            var title = (wrapper.dataset.title || '').toLowerCase();

            if (!title.includes('assembly services')) return;

            if (!isEligible) {
                if (!wrapper.querySelector('.assembly-service-msg')) {
                    var message = document.createElement('p');
                    message.className = 'assembly-service-msg';
                    message.textContent = 'Assembly service isn’t offered in your selected location. To proceed with checkout, please remove this item from your cart.';
                    wrapper.appendChild(message);
                }
                hasAssemblyMessage = true;
                return;
            }

            var existingMessage = wrapper.querySelector('.assembly-service-msg');
            if (existingMessage) {
                existingMessage.remove();
            }
        });
    }

    if (mainCartDrawerWrapper) {
        mainCartDrawerWrapper.querySelectorAll('.itg_cart_item_wrapper').forEach(function (wrapper) {
            var cartItem = wrapper.querySelector('.cart-item');
            if (!cartItem) return;

            var title = (cartItem.dataset.title || '').toLowerCase();
            if (!title.includes('assembly services')) return;

            if (!isEligible) {
                if (!wrapper.querySelector('.assembly-service-msg')) {
                    var message = document.createElement('p');
                    message.className = 'assembly-service-msg';
                    message.textContent = 'Assembly service isn’t offered in your selected location. To proceed with checkout, please remove this item from your cart.';
                    wrapper.appendChild(message);
                }
                hasAssemblyMessage = true;
                return;
            }

            var existingMessage = wrapper.querySelector('.assembly-service-msg');
            if (existingMessage) {
                existingMessage.remove();
            }
        });
    }

    document.querySelectorAll('button#CheckOut').forEach(function (btn) {
        btn.disabled = hasAssemblyMessage;
        btn.style.opacity = hasAssemblyMessage ? 0.5 : 1;
        btn.style.pointerEvents = hasAssemblyMessage ? 'none' : 'auto';
    });
}

document.addEventListener("DOMContentLoaded", updateProgressBar);
document.addEventListener('DOMContentLoaded', function () {
    itgInitCartAvailabilityObserver();
    setTimeout(function () {
        itgApplyAssemblyEligibilityState(itgReadAssemblyEligibility());
    }, 500);
    var cartForm = document.getElementById('AjaxCartForm');
    if (
        cartForm &&
        (cartForm.querySelector('[data-shipping-id]') ||
            cartForm.querySelector('[data-shipping-item-id]'))
    ) {
        itgScheduleAvailabilityRefresh({ forceReset: false, delay: 200 });
    }
});

document.addEventListener('click', async (event) => {
    const btn = event.target.closest('.add-to-cart-btn');
    if (!btn) return; // Exit if it's not the button

    event.preventDefault(); // Prevent default behavior only for the button

    // Get variant ID from form input
    const formInput = btn.closest('.itgProduct-card__form')?.querySelector('input[name="id"]');
    if (!formInput) return;

    const variantId = formInput.getAttribute('value');
    if (!variantId) return;

    // Add product to cart
    await addProductToCart(variantId, 1);

    const accordion = btn.closest('.main_free_product_accordion_wrapper');

    // Remove only the single product wrapper
    const productWrapper = btn.closest('.single_step_product_wrapper');
    if (productWrapper) productWrapper.remove();

    // If no more products remain, remove the entire Free Products accordion
    if (accordion && accordion.querySelectorAll('.single_step_product_wrapper').length === 0) {
        accordion.remove();
    }
});

document.addEventListener('click', async (event) => {
    const button = event.target.closest('.button.assembly-variant-form, .button.warranty-variant-form');
    if (!button) return;

    event.preventDefault();

    const formInput = button.querySelector('input[name="id"]');
    if (!formInput) return;

    const variantId = formInput.getAttribute('value') || formInput.value;
    if (!variantId) return;

    await addServiceVariantToCart(variantId);
});


    function newUpdateCartDrawer(){
                        setTimeout(function () {
                            itgApplyAssemblyEligibilityState(itgReadAssemblyEligibility());
                        }, 500);
                        
						const subTotalElem = document.getElementById('AjaxCartSubtotal');
						if (!subTotalElem) return;

						let subTotalAmt = subTotalElem.querySelector('.cart__total')?.getAttribute("data-total-price");
						if (!subTotalAmt) return;

					
						let cartPrice = parseFloat(subTotalAmt.replace(/,/g, '').trim());

						const mainProgressWrapper = document.querySelector('.cart_drawer_progress_bar_inner_wrapper');
						if (!mainProgressWrapper) return;

						const cartBar = mainProgressWrapper.querySelector(".cart_drawer_progress_bar");
						if (!cartBar) return;

						const maxAmountPrice = parseFloat(cartBar.getAttribute("data-maxamt"));
						if (isNaN(maxAmountPrice) || maxAmountPrice <= 0) return;

						(async () => {
							// Fetch current cart
							const cartResponse = await fetch('/cart.js');
							const cart = await cartResponse.json();

							let allProductsHTML = '';

							const mainProgressWrapper = document.querySelector('.cart_drawer_progress_bar_inner_wrapper');
							if (!mainProgressWrapper) return;

							const cartBar = mainProgressWrapper.querySelector(".cart_drawer_progress_bar");
							if (!cartBar) return;

							const maxAmountPrice = parseFloat(cartBar.getAttribute("data-maxamt"));
							const subTotalElem = document.getElementById('AjaxCartSubtotal')?.querySelector('.cart__total');
							const cartPrice = parseFloat(subTotalElem?.getAttribute("data-total-price")?.replace(/,/g, '').trim() || 0);

							const allSteps = mainProgressWrapper.querySelectorAll(".progbar_counter");
							if (!allSteps.length) return;

                            allSteps.forEach((step, index) => {
								const stepAmount = parseFloat(step.getAttribute("data-amount"));
								if (isNaN(stepAmount) || maxAmountPrice <= 0) return;

								step.style.left = Math.round((stepAmount / maxAmountPrice) * 100) + "%";

								const productElem = step.querySelector(".product_or_discount");
								if (!productElem) return;

								const type = productElem.getAttribute("data-product-or-discount");
								const wrapperId = `cart_drawer_free_product_wrapper_step_${index}`;

                                const productIdOnly = productElem.querySelector('.cart_free_product_wrapper')?.getAttribute("data-product-id");

                                // IF (cartPrice >= stepAmount)

                                if (cartPrice >= stepAmount && type === "product") {

                                    // Check ANY variant of the same product
                                    const hasFreeItem = cart.items.some(item => {
                                        return item.product_id.toString() === productIdOnly.toString() && Number(item.price) === 0;
                                    });

                                    // If ANY variant exists → do NOT render
                                    const shouldRender = !hasFreeItem;

                                    if (shouldRender) {
                                        allProductsHTML += `
                                            <div class="single_step_product_wrapper" id="${wrapperId}">
                                                <div class="free_product_wrapper_inner">
                                                    ${productElem.innerHTML}
                                                </div>
                                            </div>`;
                                    }
                                }
                                else {
                                        // 1. Remove accordion HTML
                                        const mainAccordion = document.querySelector('.main_free_product_accordion_wrapper');
                                        if (mainAccordion) {
                                            const productWrapper = mainAccordion.querySelector(`#${wrapperId}`);
                                            if (productWrapper) productWrapper.remove();
                                        }
                                        // 2. Remove only free variant from cart
                                        if (type === "product") {
                                            const matchedItems = cart.items.filter(item => {
                                                return item.product_id.toString() === productIdOnly.toString();
                                            });
                                            matchedItems.forEach(item => {
                                                if (Number(item.price) === 0) {
                                                    removeProductFromCart(item.variant_id);
                                                } else {
                                                    // console.log("Keeping paid variant:", item.variant_id);
                                                }
                                            });
                                        }
                                    }

                            });

                            let sidebarWrapper = document.querySelector('.sidebar__free_product_wrapper');

                            let cartPageWrapper = document.querySelector('.cart-form__items .sidebar__free_product_wrapper');

                            if (!cartPageWrapper && document.body.classList.contains('template-cart')) {
                                const cartItemsWrapper = document.querySelector('.cart-form__items');
                                if (cartItemsWrapper) {
                                    cartPageWrapper = document.createElement('div');
                                    cartPageWrapper.classList.add('sidebar__free_product_wrapper');
                                    cartItemsWrapper.appendChild(cartPageWrapper);
                                }
                            }

                            if (cartPageWrapper) {
                                cartPageWrapper.innerHTML = '';
                                cartPageWrapper.classList.remove('hideWrapper');

                                if (allProductsHTML.trim() !== '') {
                                    const wrapper = document.createElement('div');
                                    wrapper.classList.add('main_free_product_accordion_wrapper');
                                    wrapper.innerHTML = `
                                        <div class="headerItg active" style="cursor:pointer; display:flex; justify-content:space-between; align-items:center;">
                                            <span class="productTitleItg">Free Gift</span>
                                            <span class="svg-wrapper accordion_down_icon">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
                                                    <path d="M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z"/>
                                                </svg>
                                            </span>
                                        </div>
                                        <div class="free_product_wrapper" style="display:block;">
                                            <div class="free_product_inner_container">
                                                ${allProductsHTML}
                                            </div>
                                        </div>
                                    `;

                                    wrapper.querySelector('.headerItg').addEventListener('click', () => {
                                        const content = wrapper.querySelector('.free_product_wrapper');
                                        content.style.display = content.style.display === 'block' ? 'none' : 'block';
                                    });

                                    cartPageWrapper.appendChild(wrapper);
                                } else {
                                    cartPageWrapper.classList.add('hideWrapper');
                                }
                            }

							// CART DRAWER: clear previous content
							if (sidebarWrapper) {
								sidebarWrapper.innerHTML = '';
							}
						
							// Only build accordion if there are products
							if (allProductsHTML.trim() !== '') {
								const wrapper = document.createElement('div');
								wrapper.classList.add('main_free_product_accordion_wrapper');
								wrapper.innerHTML = `
									<div class="headerItg active" style="cursor:pointer; display:flex; justify-content:space-between; align-items:center;">
										<span class="productTitleItg">Free Gift</span>
										<span class="svg-wrapper accordion_down_icon">
											<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
												<path d="M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z"/>
											</svg>
										</span>
									</div>
									<div class="free_product_wrapper" style="display:block;">
										<div class="free_product_inner_container">
											${allProductsHTML}
										</div>
									</div>
								`;

								// Toggle accordion
								wrapper.querySelector('.headerItg').addEventListener('click', () => {
									const content = wrapper.querySelector('.free_product_wrapper');
									content.style.display = content.style.display === 'block' ? 'none' : 'block';
								});

								sidebarWrapper.appendChild(wrapper);
							} else {
								sidebarWrapper.classList.add('hideWrapper');
							}
						})();

						// Filled bar
						if (!isNaN(cartPrice)) {
							let filledPercent = ((cartPrice * 100) / maxAmountPrice);
							filledPercent = Math.min(Math.max(filledPercent, 0), 100);

							const filledBar = cartBar.querySelector(".cart_drawer_filled_bar");
							if (filledBar) {
								filledBar.style.width = filledPercent + "%";

							}
						}

						// subtotalAmt Updated

						// console.log(subTotalAmt);
						document.querySelector('.cart_drawer_progress_bar').setAttribute("data-cart-price" , subTotalAmt ) ;
						localStorage.setItem('loadedCartPrice', subTotalAmt);

					// removeProductFromCart  function //

					async function removeProductFromCart(productVariantId) {
						try {
							const lineItemElem = document.querySelector(`#item-${productVariantId}`);

							if (lineItemElem) {
								const removeBtn = lineItemElem.querySelector('a.remove, button.remove');

								if (removeBtn) {
									removeBtn.click(); // trigger click on the remove button
									// await updateCartDrawer() ;

								} else {
									console.warn(`Remove button not found for variant ${productVariantId}`);
								}
							} else {
								console.warn(`Line item not found in DOM for variant ${productVariantId}`);
							}
						} catch (err) {
							console.error(`Error removing variant ${productVariantId}:`, err);
						}
					}	
    }

    function updateCartQty(item, newQty){

        let alert = null;
        document.getElementById('AjaxCartForm').classList.add('processing');
        if ( document.getElementById('AjaxCartForm').querySelector('.alert') ) {
            document.getElementById('AjaxCartForm').querySelector('.alert').remove();
        }

        const body = JSON.stringify({
            line: parseInt(item.dataset.line),
            quantity: newQty
        });

        fetch(KROWN.settings.routes.cart_change_url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
                body
            })
            .then(response => response.json())
            .then(response => {
                if ( response.status == 422 ) {
                    // wrong stock logic alert
                    alert = document.createElement('span');
                    alert.classList.add('alert', 'alert--error');
                    if ( typeof response.description === 'string' ) {
                        alert.innerHTML = response.description;
                    } else {
                        alert.innerHTML = response.message;
                    }
                }
                return fetch('?section_id=helper-cart');
            })
            .then(response => response.text())
            .then(text => {

                const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
                const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
                const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

                const cartItems = document.getElementById('AjaxCartForm');
                cartItems.innerHTML = cartFormInnerHTML;
                rebindAjaxCartForm(cartItems);

                document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
                    elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
                });
                document.querySelectorAll('[data-header-cart-total]').forEach(elm=>{
                    elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
                });

                if ( alert !== null ) {	
                    document.getElementById('AjaxCartForm').prepend(alert);
                } 

                document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
                newUpdateCartDrawer() ;
                triggerAvailabilityRefresh({ forceReset: true, delay: 220 });

                const event = new Event('cart-updated');
                document.getElementById('AjaxCartForm').dispatchEvent(event);

            })
            .catch(e => {
                console.log(e);
                let alert = document.createElement('span');
                alert.classList.add('alert', 'alert--error');
                alert.textContent = KROWN.settings.locales.cart_general_error;
                document.getElementById('AjaxCartForm').prepend(alert);
            })
            .finally(() => {
                document.getElementById('AjaxCartForm').classList.remove('processing');
            });
    }

    function ajaxifyCartItems(cartItemsContainer) {
        cartItemsContainer.querySelectorAll('[data-js-cart-item]').forEach(item => {
            const remove = item.querySelector('.remove');
            if (remove) {       
                remove.dataset.href = remove.getAttribute('href');
                remove.setAttribute('href', '');
                remove.addEventListener('click', (e) => {
                    e.preventDefault();
                    updateCartQty(item, 0);
  
                });
            }

        });
    }

    function rebindAjaxCartForm(cartItemsContainer) {
        if (!cartItemsContainer) return;

        if (typeof cartItemsContainer.ajaxifyCartItems === 'function') {
            cartItemsContainer.ajaxifyCartItems();
        } else if (typeof ajaxifyCartItems === 'function') {
            ajaxifyCartItems(cartItemsContainer);
        }
    }

    function triggerAvailabilityRefresh(options) {
        if (
            typeof window !== 'undefined' &&
            typeof window.itgScheduleAvailabilityRefresh === 'function'
        ) {
            window.itgScheduleAvailabilityRefresh(options);
        }
    }

    async function addProductToCart(productVariantId, quantity = 1) {
        try {

                const properties = {
                   _free_product: 0  
                };

                await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        id: productVariantId,
                        quantity,
                        properties
                    })
                });

                await updateCartDrawer();
                await updateProgressBar(); 

                // updateCartContents({ showOverlay: true });

                fetch('?section_id=helper-cart')
                    .then((response) => response.text())
                    .then((text) => {

                        // console.log("inside modified fetch") ;
                        const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
                        const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;

                        const cartItems = document.getElementById('AjaxCartForm');
                        cartItems.innerHTML = cartFormInnerHTML;
                        rebindAjaxCartForm(cartItems);

                        document
                            .querySelectorAll('[data-header-cart-count]')
                            .forEach((element) => {
                                element.textContent = document.querySelector(
                                    '#AjaxCartForm [data-cart-count]'
                                ).textContent
                            })
                        document
                            .querySelectorAll('[data-header-cart-total]')
                            .forEach((element) => {
                                element.textContent = document.querySelector(
                                    '#AjaxCartForm [data-cart-total]'
                                ).textContent
                            })

                        triggerAvailabilityRefresh({ forceReset: true, delay: 260 });

                    })
                    .catch((error) => {
                        console.error('Error updating cart contents:', error)
                    })
            } catch (err) {
                console.error(`Error adding variant ${productVariantId}:`, err);
            }
        }

    async function addServiceVariantToCart(productVariantId) {
        try {
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    items: [{ id: productVariantId, quantity: 1 }]
                })
            });

            if (!response.ok) {
                let message = 'Cart add failed';

                try {
                    const payload = await response.json();
                    if (typeof payload?.description === 'string' && payload.description) {
                        message = payload.description;
                    } else if (typeof payload?.message === 'string' && payload.message) {
                        message = payload.message;
                    }
                } catch (_error) {
                    message = `Cart add failed with status ${response.status}`;
                }

                throw new Error(message);
            }

            await updateCartDrawer();
            await updateProgressBar();
        } catch (error) {
            console.error('Error adding to cart:', error);
        }
    }


    async function updateCartDrawer() {
            // console.log("updateCartDrawer functions called") ;
            try {
                const response = await fetch('?section_id=helper-cart');
                const text = await response.text();

                const parser = new DOMParser();
                const doc = parser.parseFromString(text, 'text/html');

                const cartForm = doc.getElementById('AjaxCartForm').innerHTML;
                const cartSubtotal = doc.getElementById('AjaxCartSubtotal').innerHTML;

                const cartItems = document.getElementById('AjaxCartForm');
                cartItems.innerHTML = cartForm;
                rebindAjaxCartForm(cartItems);
                document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotal;

                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = cartSubtotal;

                const cartTotalElem = tempDiv.querySelector(".cart__total");
                const cartTotalNew = cartTotalElem ? cartTotalElem.getAttribute("data-total-price") : 0;

                // console.log(cartTotalNew);

                document.querySelector('.cart_drawer_progress_bar').setAttribute("data-cart-price" , cartTotalNew) ;
                localStorage.setItem('loadedCartPrice', cartTotalNew);

                const cartCount = doc.querySelector('#AjaxCartForm [data-cart-count]').textContent;
                document.querySelectorAll('[data-header-cart-count]').forEach(element => {
                    element.textContent = cartCount;
                });

                const cartTotal = doc.querySelector('#AjaxCartForm [data-cart-total]').textContent;
                document.querySelectorAll('[data-header-cart-total]').forEach(element => {
                    element.textContent = cartTotal;
                });

                triggerAvailabilityRefresh({ forceReset: true, delay: 260 });

            } catch (error) {
                console.error('Error updating cart contents:', error);
            }
            if (typeof window !== 'undefined' && window.__INTERNAL_TEST_MODE__) {
                newUpdateCartDrawer();
            } else {
                setTimeout(()=>{
                    newUpdateCartDrawer() ;
                },1000) ;
            }
    }

    async function removeProductFromCart(productVariantId) {
        try {
            // Target the line item div by variantId
            const lineItemElem = document.querySelector(`#item-${productVariantId}`);

            if (lineItemElem) {
                // Find the remove button inside this line item
                const removeBtn = lineItemElem.querySelector('a.remove, button.remove');

                if (removeBtn) {
                    removeBtn.click(); // trigger click on the remove button
                    await updateCartDrawer() ;
                } else {
                    console.warn(`Remove button not found for variant ${productVariantId}`);
                }
            } else {
                console.warn(`Line item not found in DOM for variant ${productVariantId}`);
            }
        } catch (err) {
            console.error(`Error removing variant ${productVariantId}:`, err);
        }
    }

async function updateProgressBar() {

    const main_progress_wrapper = document.querySelector('.cart_drawer_progress_bar_inner_wrapper');
    if (!main_progress_wrapper) return;

    const cartBar = main_progress_wrapper.querySelector(".cart_drawer_progress_bar");
    const maxAmountPrice = parseFloat(cartBar?.getAttribute("data-maxamt"));
    const cartPrice = parseFloat(cartBar?.getAttribute("data-cart-price"));

    if (isNaN(maxAmountPrice) || isNaN(cartPrice)) return;

    localStorage.setItem('loadedCartPrice', cartPrice);

    const allSteps = main_progress_wrapper.querySelectorAll(".progbar_counter");

    // Fetch current cart once
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();

    // Filled bar
    const filledBar = cartBar.querySelector(".cart_drawer_filled_bar");
    if (filledBar && maxAmountPrice > 0) {
        let filledPercent = ((cartPrice * 100) / maxAmountPrice);
        filledPercent = Math.min(Math.max(filledPercent, 0), 100);
        filledBar.style.width = filledPercent + "%";
    }

     let allProductsHTML = '';

    allSteps.forEach((step, index) => {
        const stepAmount = parseFloat(step.getAttribute("data-amount"));
        if (isNaN(stepAmount) || maxAmountPrice <= 0) return;

        step.style.left = Math.round((stepAmount / maxAmountPrice) * 100) + "%";

        const productElem = step.querySelector(".product_or_discount");
        if (!productElem) return;

        const type = productElem.getAttribute("data-product-or-discount");
        const wrapperId = `cart_drawer_free_product_wrapper_step_${index}`;
        const productIdOnly = productElem.querySelector('.cart_free_product_wrapper')?.getAttribute("data-product-id");
        // IF (cartPrice >= stepAmount)

        if (cartPrice >= stepAmount && type === "product") {

            // Check ANY variant of the same product
            const hasFreeItem = cart.items.some(item => {
                return item.product_id.toString() === productIdOnly.toString() && Number(item.price) === 0;
            });

            // If ANY variant exists → do NOT render
            const shouldRender = !hasFreeItem;

            if (shouldRender) {
                allProductsHTML += `
                    <div class="single_step_product_wrapper" id="${wrapperId}">
                        <div class="free_product_wrapper_inner">
                            ${productElem.innerHTML}
                        </div>
                    </div>`;
            }
        }
        else {
                // 1. Remove accordion HTML
                const mainAccordion = document.querySelector('.main_free_product_accordion_wrapper');
                if (mainAccordion) {
                    const productWrapper = mainAccordion.querySelector(`#${wrapperId}`);
                    if (productWrapper) productWrapper.remove();
                }
                // 2. Remove only free variant from cart
                if (type === "product") {
                    const matchedItems = cart.items.filter(item => {
                        return item.product_id.toString() === productIdOnly.toString();
                    });
                    matchedItems.forEach(item => {
                        if (Number(item.price) === 0) {
                            removeProductFromCart(item.variant_id);
                        } else {
                            // console.log("Keeping paid variant:", item.variant_id);
                        }
                    });
                }
            }

        });

            let sidebarWrapper = document.querySelector('.sidebar__free_product_wrapper');
            let cartPageWrapper = document.querySelector('.cart-form__items .sidebar__free_product_wrapper');

            if (!cartPageWrapper && document.body.classList.contains('template-cart')) {
                const cartItemsWrapper = document.querySelector('.cart-form__items');
                if (cartItemsWrapper) {
                    cartPageWrapper = document.createElement('div');
                    cartPageWrapper.classList.add('sidebar__free_product_wrapper');
                    cartItemsWrapper.appendChild(cartPageWrapper);
                }
            }

            if (cartPageWrapper) {
                cartPageWrapper.innerHTML = '';
                cartPageWrapper.classList.remove('hideWrapper');

                if (allProductsHTML.trim() !== '') {
                    const wrapper = document.createElement('div');
                    wrapper.classList.add('main_free_product_accordion_wrapper');
                    wrapper.innerHTML = `
                        <div class="headerItg active" style="cursor:pointer; display:flex; justify-content:space-between; align-items:center;">
                            <span class="productTitleItg">Free Gift</span>
                            <span class="svg-wrapper accordion_down_icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
                                    <path d="M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z"/>
                                </svg>
                            </span>
                        </div>
                        <div class="free_product_wrapper" style="display:block;">
                            <div class="free_product_inner_container">
                                ${allProductsHTML}
                            </div>
                        </div>
                    `;

                    wrapper.querySelector('.headerItg').addEventListener('click', () => {
                        const content = wrapper.querySelector('.free_product_wrapper');
                        content.style.display = content.style.display === 'block' ? 'none' : 'block';
                    });

                    cartPageWrapper.appendChild(wrapper);
                } else {
                    cartPageWrapper.classList.add('hideWrapper');
                }
            }

            // CART DRAWER: clear previous content
            if (sidebarWrapper) {
                sidebarWrapper.innerHTML = '';
            }

            // Only build accordion if there are products
            if (allProductsHTML.trim() !== '') {
                const wrapper = document.createElement('div');
                wrapper.classList.add('main_free_product_accordion_wrapper');
                wrapper.innerHTML = `
                    <div class="headerItg active" style="cursor:pointer; display:flex; justify-content:space-between; align-items:center;">
                        <span class="productTitleItg">Free Gift</span>
                        <span class="svg-wrapper accordion_down_icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
                                <path d="M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z"/>
                            </svg>
                        </span>
                    </div>
                    <div class="free_product_wrapper" style="display:block;">
                        <div class="free_product_inner_container">
                            ${allProductsHTML}
                        </div>
                    </div>
                `;

                // Toggle accordion
                wrapper.querySelector('.headerItg').addEventListener('click', () => {
                    const content = wrapper.querySelector('.free_product_wrapper');
                    content.style.display = content.style.display === 'block' ? 'none' : 'block';
                });
                sidebarWrapper.appendChild(wrapper);
            } else {
                sidebarWrapper.classList.add('hideWrapper');
            }
}
